import RatingStarWrapper from './RatingStarWrapper';
export type { RatingStarProps } from './RatingStar.types';

export default RatingStarWrapper;
